import { useState } from 'react';

export const useConfirmDialog = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [action, setAction] = useState<(() => Promise<void>) | null>(null);

  const handleOpen = (message: string, action: () => Promise<void>) => {
    setMessage(message);
    setAction(() => action);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setMessage('');
    setAction(null);
  };

  const handleConfirm = async () => {
    if (action) {
      await action();
      handleClose();
    }
  };

  return {
    open,
    message,
    handleOpen,
    handleClose,
    handleConfirm,
  };
}; 